export const getOutputData = (responseData: any) => {
  if (responseData?.outputs?.PDC) {
    return Object.entries(responseData?.outputs?.PDC[responseData?.outputs?.PDC?.length - 1]).map(
      (t: any, k: number) => {
        return { y: t[1], x: t[0] }
      }
    )
  }
  return []
}

